
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { gitlabTranslationRef } from '@immobiliarelabs/backstage-plugin-gitlab';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const gitlabTranslations: any = TranslationBlueprint.make({
  name: 'gitlab-pt-BR',

  params: {
    resource: createTranslationResource({
      ref: gitlabTranslationRef,
      translations: {
        'pt-BR': () => import('./gitlab-ptbr'),
      },
    }),
  },
});